//@ts-nocheck
import "./sty.css";
import Modal from "../modal";
import React, { useState, useEffect } from "react";
import { Typography, Button, Icon } from "../index";
import { Trn } from "../../../translations/language";

type hintType = {
  open: boolean;
  header?: string;
  onHelp: Function;
  onClose: Function;
  onAccept: Function;
  onReject: Function;
  acceptText: string;
  rejectText: string;
  children?: React.ReactNode;
};
export default function HintModal(props: hintType) {
  const { open, onClose, header, children, onAccept, onReject, showAgain, onShowAgain,acceptText, rejectText } = props;

  const [show, setShow] = useState(open);

  useEffect(() => {
    setShow(open);
    
  }, [open]);

  return (
    <Modal open={show} onClose={() => onClose?.()} className="hitModal">
      <Modal.Body>
        <div className="hintModalHeader d-flex">
          <Typography variant="subtitle2" className="text-center w-100">
            {header}
          </Typography>

          <Icon name="angle-down" onClick={() => onClose?.()} />
        </div>
        {children}

        <div className="actions">
          {/*<Button className="" size="sm" onClick={() => onHelp?.()}>
            {Trn({ text: "help" })}
          </Button>*/}
          {showAgain ? (
              <Button className=" mx-2" size="sm" onClick={() => onShowAgain?.()}>
                {rejectText || Trn({ text: "deny_access" })}
              </Button>
          ) : ''}

          <Button className=" mx-2" size="sm" onClick={() => onReject?.()}>
            {acceptText || Trn({ text: "get_access" })}
          </Button>

          <Button size="sm" color="primary" onClick={() => onAccept?.()}>
            {Trn({ text: "get_access" })}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
